import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const getLegalContent = (type) => {
  return Api(
    endPoints.legalContent.replace(":type", type),
    null,
    requestType.GET,
  );
};

export { getLegalContent };
